class SessionStorageManager {
  /**
   *
   *  Store value in session storage
   *
   * @param key
   * @param value
   * @returns
   */
  storeJson(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
    return this;
  }

  /**
   *
   *  Get value from session storage
   *
   * @param key
   * @returns
   */
  getJson(key: string) {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  /**
   *  Get value from session storage
   *
   * @param key
   * @returns
   */
  remove(key: string) {
    sessionStorage.removeItem(key);
    return this;
  }

  /**
   * Clear all session storage
   *
   * @returns
   */
  clear() {
    sessionStorage.clear();
    return this;
  }

  getApplicationSettings() {
    return this.getJson('application_settings');
  }

  storeApplicationSettings(settings: any) {
    let currentSettings = this.getApplicationSettings() || {};

    let newSettings = {
      ...currentSettings,
      ...settings
    };

    return this.storeJson('application_settings', newSettings);
  }
}

export default new SessionStorageManager();
